(() => {
  const revealHash = () => {
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    const target = id && document.getElementById(id);
    if (!target) return;
    let details = target.closest('details');
    while (details) {
      details.open = true;
      details = details.parentElement?.closest('details');
    }
    requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[data-bbm-video]');
    if (!button) return;
    const candidate = matchMedia('(max-width: 700px)').matches ? button.dataset.mobileUrl : button.dataset.desktopUrl;
    let source;
    try { source = new URL(candidate); } catch { return; }
    if (source.protocol !== 'https:' || source.hostname !== 'cdn.shopify.com') return;
    const video = document.createElement('video');
    video.controls = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.preload = 'none';
    video.setAttribute('preload', 'none');
    video.tabIndex = 0;
    video.setAttribute('aria-label', button.dataset.title || 'Reference video');
    video.width = Number(button.dataset.width) || 720;
    video.height = Number(button.dataset.height) || 1280;
    if (button.dataset.poster) video.poster = button.dataset.poster;
    video.src = source.href;
    button.replaceWith(video);
    video.focus();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealHash, { once: true });
  else revealHash();
  addEventListener('hashchange', revealHash);
  document.addEventListener('shopify:section:load', revealHash);
})();
